<template>
    <div class="article">
        <Headline/>
        <BackButton class="backButton"/>
        <h3 class="label" v-html="title"></h3>
        <p v-html="reply" class="reply speechBubble-right halfWidth"></p>
        <p v-html="text" ref="text" class="dontBreakOut text speechBubble-left halfWidth"></p>
    </div>
</template>

<script>
    import {Vue, Component } from "vue-property-decorator";
    import VueScrollTo from "vue-scrollto";
    import answers from "@/assets/answers";
    import Headline from "@/components/Headline";
    import BackButton from "@/components/BackButton";
    import BasicComponent from "@/components/BasicComponent";

    @Component({
        components: {BackButton, Headline},
        props: {
            id: Number
        }
    })
    export default class Article extends BasicComponent {

        data() {
            return {
                answers: answers
            }
        }

        mounted() {
            setTimeout(() => VueScrollTo.scrollTo(this.$refs.text, 1000, {
                cancelable: false
            }), 500);
            this.trackPage(this.title);
        }

        searchQuestion(id) {
            return this.$data.answers[Number(id)];
        }

        get question() {
            return this.searchQuestion(this.$props.id);
        }

        get title() {
            return this.question.title;
        }

        get reply() {
            return this.question.description;
        }

        get text() {
            return this.question.text;
        }


    }
</script>
<style scoped lang="scss">
    @import "@/stylesheets/SpeechBubble.scss";

    .article {

        $titleFontSize: 40px;

        width: 90vw;
        max-width: 1000px;
        margin: 0 auto;

        .blabla {
            height: 180px;
            margin-right: 100%;
            max-width: 90vw;
        }

        .label {
            position: relative;
            right: 6px;
            text-align: right;
            font-weight: 900;
            font-size: $titleFontSize;
            font-variant: small-caps;
            margin-bottom: -26px;
            line-height: 1;
        }

        .text {
            font-size: 20px;
            line-height: 30px;
            text-align: left;
            hyphens: auto;

            padding: 15px;

            * {
                hyphens: auto;
            }
        }

        .reply {
            font-size: 20px;
            line-height: 30px;
            text-align: justify;
            text-justify: inter-word;
            hyphens: auto;

            padding: 15px;
        }
    }
</style>
